import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoggerService, AuthService, NotificationService, Utils, AsyncCommunicationService } from './';
import { ErrorDialogService } from './error.dialog.service';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule 
  ],
  providers: [
    LoggerService,
    AuthService,
    NotificationService,
    Utils,
    ErrorDialogService,
    AsyncCommunicationService
  ],
  exports: [
    CommonModule,
    FormsModule,
    TranslateModule  
  ]
})

export class SharedModule { }
